/* @flow */
import { reducer, initialState } from 'payments/reducers/ExternalAccountResource';
import { ReduceStore } from 'flux/utils';
import { dispatcher } from 'lib/Dispatcher';

class ExternalAccountResourceStore extends ReduceStore {
  getInitialState() {
    return initialState;
  }

  getExternalAccountResources() {
    return this.getState().externalAccountResources;
  }

  getBankAccounts() {
    return this.getState().externalAccountResources.map(ea => ea.getBankAccount());
  }

  reduce(state, action) {
    return reducer(state, action);
  }
}

export default new ExternalAccountResourceStore(dispatcher);



// WEBPACK FOOTER //
// ./src/payments/stores/ExternalAccountResourceStore.js